const GOOGLE_TRANSLATE_COOKIE = 'googtrans';

const expireCookie = (name: string, attributes: string) => {
  document.cookie = `${name}=; ${attributes}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const disableExternalPageTranslation = () => {
  if (typeof document === 'undefined') return;

  document.documentElement.classList.add('notranslate');
  document.documentElement.setAttribute('translate', 'no');
  document.body?.classList.add('notranslate');
  document.body?.setAttribute('translate', 'no');

  const hostnameParts = window.location.hostname.split('.');
  const domainCandidates = hostnameParts.flatMap((_, index) => {
    const domain = hostnameParts.slice(index).join('.');
    return domain ? [`domain=${domain}`, `domain=.${domain}`] : [];
  });

  const attributeCandidates = ['path=/', ...domainCandidates.map(domain => `path=/; ${domain}`)];

  for (const attributes of attributeCandidates) {
    expireCookie(GOOGLE_TRANSLATE_COOKIE, attributes);
  }
};
